import type { Child, Spouse } from '@hc-frontend/core-types';
import { TobaccoUse } from '@hc-frontend/core-types';
import { dateToAge } from '@hc-frontend/core-utils-date';
import { isDefined } from '@hc-frontend/core-utils-validations';

export function formatDependent({
  tobaccoUse,
  dateOfBirth,
}: Partial<Spouse | Child>) {
  if (!isDefined(tobaccoUse)) {
    return null;
  }

  let value = `${tobaccoUse === TobaccoUse.Enum.YES ? 'Smoker' : 'Non-Smoker'}`;
  const age = dateOfBirth ? dateToAge(dateOfBirth) : null;
  if (isDefined(age)) {
    value += `, ${age}`;
  }

  return value;
}
